import type { TabPaneProps } from 'antd';
import { Tabs } from 'antd';
import styled from 'styled-components';
import { devices } from '../const/devices';
import { useIsMobileL } from '../hooks/useBreakpoint';

const StyledTabs = styled(Tabs)<{ $useCardBody?: boolean }>`
	.ant-tabs-nav {
		margin: 0;

		&::before {
			border-bottom: none;
		}
	}

	.ant-tabs-tab {
		box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
		background: #f3f5f7;
		border-left: 1px solid #f0f0f0;
		border-right: 1px solid #f0f0f0;
		border-top: 1px solid #f0f0f0;
	}

	.ant-tabs-tab-active {
		background: #ffffff;
	}

	.ant-tabs-nav-wrap {
		z-index: 10 !important;
		/* position: absolute !important; */
	}

	.ant-tabs-content-holder {
		background-color: ${props => (props.$useCardBody ? 'white' : '')};
		padding: ${props => (props.$useCardBody ? '1em' : '0')};

		border-radius: 0px 4px 4px 4px !important;
		border: ${props => (props.$useCardBody ? '1px solid #f0f0f0 !important' : '')};
		box-shadow: ${props => (props.$useCardBody ? '0px 1px 3px rgba(0, 0, 0, 0.1);' : '')};
	}

	@media ${devices.mobileL} {
		.ant-tabs-nav {
			width: 100%;
		}

		.ant-tabs-nav-wrap {
			width: 100%;
		}

		.ant-tabs-nav-list {
			width: 100%;
		}

		.ant-tabs-tab {
			border-radius: 0 0 0 0 !important;
			border: none;
			flex: 1;
			margin: 0 !important;
			display: grid;
			place-items: center;
			box-shadow: none;
			background: transparent;
		}

		.ant-tabs-tab-active {
			background: transparent;
		}
	}
`;

interface Tab extends Omit<TabPaneProps, 'tab'> {
	key: string;
	label: React.ReactNode;
}

interface Props {
	useCardBody?: boolean;
	items: Tab[];
	onTabClick?: (key: string) => void;
	defaultActiveKey?: string;
}

const SimpleTabs: React.FC<Props> = ({ items, defaultActiveKey, useCardBody, onTabClick }) => {
	const isMobile = useIsMobileL();
	return (
		<StyledTabs
			tabPosition="top"
			destroyInactiveTabPane
			$useCardBody={useCardBody}
			size="large"
			type={isMobile ? 'line' : 'card'}
			onTabClick={(k: string): void => {
				onTabClick?.(k);
			}}
			items={items}
			defaultActiveKey={defaultActiveKey}
		/>
	);
};

export default SimpleTabs;
